import type { IRemoteNotification } from '@suprsend/react';
import { decode } from 'html-entities';

export function notificationFromSuprSend(notification: IRemoteNotification) {
  const { message } = notification;
  return {
    ...notification,
    message: {
      title: decode(message.header ?? '', { scope: 'strict' }),
      body: decode(message.text, { scope: 'strict' }),
      subtext: message.subtext
        ? decode(message.subtext.text, { scope: 'strict' })
        : undefined,
      actions: message.actions?.map(({ name, ...action }) => ({
        ...action,
        label: decode(name, { scope: 'strict' })
      }))
    }
  };
}

export type Notification = ReturnType<typeof notificationFromSuprSend>;
